import * as ProfileTypes from '../profileTypes';

export interface FormData {
    firstName: string;
    middleName?: string;
    lastName: string;

    dateOfBirth: string;

    birthHospital: string;
    birthCity: string;
    birthDistrict?: string;
    birthCounty?: string;
    birthState?: ProfileTypes.StateNotUnknown;

    fatherName?: string;
    fatherMaidenName?: string;
    fatherBirthCity?: string;
    fatherBirthCounty?: string;
    fatherBirthState?: ProfileTypes.State;

    motherName?: string;
    motherMaidenName?: string;
    motherBirthCity?: string;
    motherBirthCounty?: string;
    motherBirthState?: ProfileTypes.State;

    parentsMaritalStatus: ProfileTypes.YesNoUnknown;

    adoptionStatus: ProfileTypes.YesNoUnknown;
    adoptedName?: string;
    adoptedFatherName?: string;
    adoptedMotherName?: string;
    adoptionRequestType: ProfileTypes.AdoptionRequestType;

    siblings?: ProfileTypes.Sibling[];

    votingIntent: ProfileTypes.VotingIntent;

    possessedIdTypes: ProfileTypes.PossessedIdTypes;
}